import { GetterTree } from 'vuex';
import { EAssemblerGetter } from '@/document-edit/assembler/store/assembler.constants';
import { ERecipientRole } from '@lib-shared/recipients/types/enums/recipient-role';
import { IAssemblerState } from '@/document-edit/assembler/store/assembler.types';
import { RootState } from '@/store/store';
import { IRecipient } from '@lib-shared/types/Recipient';
import { EnumDocumentType } from '@/enums/DocumentType';

export const getters: GetterTree<IAssemblerState, RootState> = {
  [EAssemblerGetter.FirstAddedRecipient](state: IAssemblerState): IRecipient {
    if (!state.document || !state.document.recipients || !state.document.recipients.length) {
      return;
    }

    return state.document.recipients.reduce((prev: IRecipient, curr: IRecipient) => {
      return new Date(prev.createdAt) < new Date(curr.createdAt) ? prev : curr;
    });
  },
  [EAssemblerGetter.SelectedRecipient](state: IAssemblerState): IRecipient {
    if (state.document && state.document.recipients && state.selectedRecipient.id) {
      return state.document.recipients.find(
        (recipient: IRecipient) => recipient.id === state.selectedRecipient.id
      );
    }
    return null;
  },
  [EAssemblerGetter.ConnectFirstRecipient](state: IAssemblerState): boolean {
    return state.selectedRecipient.connectFirstRecipient;
  },
  [EAssemblerGetter.Recipients](state: IAssemblerState): IRecipient[] {
    if (!state.document || !state.document.recipients || !state.document.recipients.length) {
      return [];
    }
    return state.document.recipients.sort(
      (a: IRecipient, b: IRecipient) => a.orderNum - b.orderNum
    );
  },
  [EAssemblerGetter.DocumentHasApprover](state: IAssemblerState): boolean {
    if (state.document && state.document.recipients && !!state.document.recipients.length) {
      return state.document.recipients.some(
        (recipient: IRecipient) => recipient.role === ERecipientRole.Approver
      );
    }
  },
  [EAssemblerGetter.IsTemplate](state: IAssemblerState): boolean {
    if (!state.document) {
      return false;
    }
    return state.document.type === EnumDocumentType.Template;
  },
};
